























import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Storage } from 'aws-amplify';

@Component
export default class S3Image extends Vue {
  private src: any = '';
  private lazySrc: any = '';

  @Prop({type: String, default: ''}) private itemKey!: string;
  @Prop({type: String, default: ''}) private itemKeyLazy!: string;
  @Prop({type: String, default: ''}) private level!: string;
  @Prop({type: Boolean, default: false}) private border!: boolean;
  @Prop({type: Boolean, default: false}) private contain!: boolean;

  private created() {
    this.init(this.itemKey);
  }

  private async init(itemKey) {
    if (this.itemKeyLazy) {
      this.lazySrc = await Storage.get(itemKey, { level: this.level ? this.level : 'public' });
    }
    this.src = await Storage.get(itemKey, { level: this.level ? this.level : 'public' });
  }


  private error() {
    this.src = './img/loader.gif';

    setTimeout(() => { this.init(this.itemKey); }, 5000);
  }

  @Watch('itemKey')
  private reloadItem() {
    this.init(this.itemKey);
  }

  private load() {
    // console.log('load');
  }
}
